import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { GtagService } from '@app/services/gtag.service';

import { environment } from '../environments/environment';

import { LoaderDOS } from './shared/services/loader-dos.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
  title = 'ip-timesheet';
  readonly loading$ = this._loaderDOS.loading$;

  private readonly onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private _loaderDOS: LoaderDOS,
    private readonly router: Router,
    private readonly gtagService: GtagService
  ) {
    this._subscribeToRouteChanges();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  // subscribe to router events and send page views to Google Analytics
  private _subscribeToRouteChanges(): void {
    if (!environment?.production) {
      return;
    }

    this.router.events.pipe(takeUntil(this.onDestroy$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.gtagService.setConfig(event.urlAfterRedirects);
        this.gtagService.setPageView();
      }
    });
  }
}
